var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48.773,
    viewBox: "0 0 48 48.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_15_1",
    "data-name": "Component 15 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Reset",
    transform: "translate(0 43.773)",
    fill: "#a4a5a5",
    fontSize: 18,
    fontFamily: "Mulish-Bold, Mulish",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reset")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    transform: "translate(-1400.379 -131.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-filter",
    "data-name": "Icon awesome-filter",
    d: "M13.175,0H.649A.648.648,0,0,0,.191,1.106L5.184,6.1v5.563a.648.648,0,0,0,.276.531l2.16,1.511a.648.648,0,0,0,1.02-.531V6.1l4.993-4.994A.648.648,0,0,0,13.175,0Z",
    transform: "translate(1418.642 141.56)",
    fill: "#a4a5a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(1410.809 131.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M177.3,279.936a2.8,2.8,0,0,1-.117-1.163,1.767,1.767,0,0,1,1.549-1.382,1.689,1.689,0,0,1,1.722,1.089c.585,1.687,1.157,3.378,1.69,5.082a1.641,1.641,0,0,1-1.545,2.117c-1.7.031-3.394.021-5.091,0a1.625,1.625,0,0,1-1.561-1.245,1.655,1.655,0,0,1,.741-1.821c.071-.047.169-.063.213-.19a10.2,10.2,0,0,0-2.67-1.183,11.387,11.387,0,1,0,8,12.983,12.514,12.514,0,0,0,.194-2.091,1.667,1.667,0,0,1,3.3-.3,5.942,5.942,0,0,1,.007,1.528,14.622,14.622,0,0,1-4.52,9.494,14.183,14.183,0,0,1-8.468,3.976,14.364,14.364,0,0,1-12.3-4.383,14.2,14.2,0,0,1-4.07-8.7,14.74,14.74,0,0,1,22.6-13.963c.076.047.15.1.228.141A.39.39,0,0,0,177.3,279.936Z",
    transform: "translate(-154.284 -277.384)",
    fill: "#a4a5a5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.12a0b85fe2193a7e84bf7bbee222964b.svg";
export { ForwardRef as ReactComponent };